"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.referendumTypes = exports.CastVote = exports.ReferendumStage = exports.ReferendumStageRevealing = exports.ReferendumStageVoting = exports.OptionResult = exports.VotePower = void 0;
const codec_1 = require("@polkadot/types/codec");
const primitive_1 = require("@polkadot/types/primitive");
const JoyStruct_1 = require("../JoyStruct");
const JoyEnum_1 = require("../JoyEnum");
const common_1 = require("../common");
class VotePower extends primitive_1.u128 {
} // Balance
exports.VotePower = VotePower;
class OptionResult extends (0, JoyStruct_1.JoyStructDecorated)({
    option_id: common_1.MemberId,
    vote_power: VotePower,
}) {
}
exports.OptionResult = OptionResult;
class ReferendumStageVoting extends (0, JoyStruct_1.JoyStructDecorated)({
    started: primitive_1.u32,
    winning_target_count: primitive_1.u64,
    current_cycle_id: primitive_1.u64,
}) {
}
exports.ReferendumStageVoting = ReferendumStageVoting;
class ReferendumStageRevealing extends (0, JoyStruct_1.JoyStructDecorated)({
    started: primitive_1.u32,
    winning_target_count: primitive_1.u64,
    intermediate_winners: codec_1.Vec.with(OptionResult),
    current_cycle_id: primitive_1.u64,
}) {
}
exports.ReferendumStageRevealing = ReferendumStageRevealing;
class ReferendumStage extends (0, JoyEnum_1.JoyEnum)({
    Inactive: primitive_1.Null,
    Voting: ReferendumStageVoting,
    Revealing: ReferendumStageRevealing,
}) {
}
exports.ReferendumStage = ReferendumStage;
class CastVote extends (0, JoyStruct_1.JoyStructDecorated)({
    commitment: common_1.Hash,
    cycle_id: primitive_1.u64,
    stake: primitive_1.u128,
    vote_for: codec_1.Option.with(common_1.MemberId),
}) {
}
exports.CastVote = CastVote;
exports.referendumTypes = {
    ReferendumStageVoting,
    ReferendumStageRevealing,
    ReferendumStage,
    OptionResult,
    VotePower,
};
exports.default = exports.referendumTypes;
